module.exports = __webpack_public_path__ + "img/15.9c10c1c7.svg";